import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7890b9e7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7890b9e7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7890b9e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7890b9e7')) {
      api.createRecord('7890b9e7', component.options)
    } else {
      api.reload('7890b9e7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7890b9e7&scoped=true", function () {
      api.rerender('7890b9e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Watermark/index.vue"
export default component.exports